import clsx from 'clsx';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { KEY_CODES } from '@/main/app.constants';
import { Icon, Checkbox as QomponentCheckbox } from '@seeqdev/qomponents';
import type { TooltipPosition } from '@seeqdev/qomponents';

interface CheckboxProps {
  id?: string;
  isChecked: boolean;
  label?: string | React.ReactNode;
  extraLabel?: React.ReactElement;
  onChange?: (event: any) => void;
  onClick?: (event: any) => void;
  value?: any;
  type?: 'radio' | 'checkbox';
  disabled?: boolean;
  classes?: string;
  tooltip?: string;
  tooltipPlacement?: TooltipPosition;
  isTooltipSimple?: boolean;
  description?: string;
  skipMemo?: boolean;
  descriptionClasses?: string;
  onHelpIconClick?: () => any;
  flexAlign?: 'start' | 'center' | 'bottom';
}

export const Checkbox = (props: CheckboxProps) => {
  const {
    onChange = _.noop,
    isChecked,
    label,
    extraLabel,
    id,
    disabled,
    type = 'checkbox',
    classes,
    tooltip,
    tooltipPlacement = 'top',
    isTooltipSimple = false,
    description,
    value,
    descriptionClasses = 'ml20 pl2 mtn5 width-200 font-size-smaller',
    onHelpIconClick,
    onClick,
    flexAlign = 'start',
  } = props;

  const { t } = useTranslation();

  return (
    <span
      className={clsx('flexColumnContainer', classes, isChecked ? 'specChecked' : 'specNotChecked', {
        flexAlignCenter: flexAlign === 'center',
        flexAlignBottom: flexAlign === 'bottom',
        flexAlignStart: flexAlign === 'start',
      })}
      data-testid={id}>
      <div className={clsx('flexColumnContainer sq-checkbox')}>
        <QomponentCheckbox
          value={value}
          onKeyDown={(e) => e.keyCode === KEY_CODES.ENTER && e.currentTarget.click()}
          onChange={onChange}
          onClick={onClick}
          checked={isChecked}
          type={type}
          id={id}
          testId={`${id}-input`}
          disabled={disabled}
          label={typeof label === 'string' ? t(label) : label}
          tooltip={tooltip && t(tooltip)}
          tooltipPlacement={tooltipPlacement}
        />
        {extraLabel}
      </div>
      {!isTooltipSimple && tooltip && (
        <Icon
          icon="fa-question-circle"
          size="lg"
          tooltip={t(tooltip)}
          tooltipPlacement={tooltipPlacement}
          extraClassNames="pl5 tw:leading-none!"
          onClick={onHelpIconClick}
          testId={`${id}Tooltip`}
        />
      )}
      {description && (
        <div className={clsx('text-italic sq-fairly-dark-gray', descriptionClasses)}>{t(description)}</div>
      )}
    </span>
  );
};
